var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import EventEmitter from 'events';
var SoundMeter = /** @class */ (function (_super) {
    __extends(SoundMeter, _super);
    function SoundMeter(threshold) {
        if (threshold === void 0) { threshold = 0.01; }
        var _this = _super.call(this) || this;
        _this.threshold = threshold;
        _this.context = null;
        _this._volume = 0.0;
        _this.mic = null;
        _this.node = null;
        _this.currentThresholdStatus = false;
        _this._frameHandle = 0;
        _this.reset = function () {
            var AudioContext = window.AudioContext || window.webkitAudioContext;
            _this.context = new AudioContext();
            _this.node = _this.context.createAnalyser();
            return { context: _this.context, node: _this.node };
        };
        _this.onFrame = function () {
            var e_1, _a;
            if (!_this.node)
                return;
            var pcmData = new Float32Array(_this.node.fftSize);
            _this.node.getFloatTimeDomainData(pcmData);
            var sumSquares = 0.0;
            try {
                for (var pcmData_1 = __values(pcmData), pcmData_1_1 = pcmData_1.next(); !pcmData_1_1.done; pcmData_1_1 = pcmData_1.next()) {
                    var amplitude = pcmData_1_1.value;
                    sumSquares += amplitude * amplitude;
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (pcmData_1_1 && !pcmData_1_1.done && (_a = pcmData_1.return)) _a.call(pcmData_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            _this._volume = Math.sqrt(sumSquares / pcmData.length);
            if (_this.currentThresholdStatus !== _this._volume > _this.threshold) {
                _this.currentThresholdStatus = _this._volume > _this.threshold;
                _this.emit('thresholdStatusChange', _this.currentThresholdStatus);
            }
            _this._frameHandle = window.requestAnimationFrame(_this.onFrame);
        };
        _this.connectToStream = function (stream) { return __awaiter(_this, void 0, void 0, function () {
            var _a, context, node;
            return __generator(this, function (_b) {
                try {
                    _a = this.reset(), context = _a.context, node = _a.node;
                    this.mic = context.createMediaStreamSource(stream);
                    this.mic.connect(node);
                    this.onConnected();
                }
                catch (e) {
                    console.error(e);
                }
                return [2 /*return*/];
            });
        }); };
        _this.onConnected = function () {
            _this._frameHandle = window.requestAnimationFrame(_this.onFrame);
        };
        _this.disconnect = function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                (_a = this.mic) === null || _a === void 0 ? void 0 : _a.disconnect();
                (_b = this.node) === null || _b === void 0 ? void 0 : _b.disconnect();
                if (this._frameHandle)
                    cancelAnimationFrame(this._frameHandle);
                return [2 /*return*/];
            });
        }); };
        return _this;
    }
    Object.defineProperty(SoundMeter.prototype, "volume", {
        /**
         * Current volume level of the source
         */
        get: function () {
            return this._volume;
        },
        enumerable: false,
        configurable: true
    });
    return SoundMeter;
}(EventEmitter));
export { SoundMeter };
//# sourceMappingURL=SoundMeter.js.map